module.exports = __webpack_public_path__ + "img/o2o08.0f3cc023.png";